import { Stack } from '@startuptools/ui/Stack';
import { Typography } from '@startuptools/ui/Typography';
import { Box } from '@startuptools/ui/Box';
import { useTheme } from '@startuptools/ui/Theme';
import { Button } from '@startuptools/ui/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { MainHeader } from './MainHeader';
import { MainCardRow } from './MainCardRow';
import { MainDynamicDivContent } from './MainDynamicDivContent';
import { MobileMainDynamicDivContent } from './MobileMainDynamicDivConent';

const dynamicDivButtonsNames = [
  'SWEAT Advisory Options',
  'Non-Disclosure Agreements',
  'Consulting Agreement',
  'Loan Agreement',
  'Articles of Association',
  'Formalities',
];

const bucketBaseUrl = 'https://storage.googleapis.com/bolago-free-templates';

const buttonsSWEAT = [
  {
    text: 'SWEAT Advisor Options',
    tooltipTitle: 'Use to compensate advisors with warrants',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-SWEAT-2021-05-10.zip`],
    docKinds: ['SWEAT'],
  },
];

const buttonsFounders = [
  {
    text: 'Articles of Association',
    tooltipTitle: '(Swedish: Bolagsordning)',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Articles-of-Association-v2-2021-05-10.docx`],
    docKinds: ['Articles of Association'],
  },
];

const buttonsNDA = [
  {
    text: 'One-Way NDA', // TODO: Ask about text
    tooltipTitle: 'To keep your secrets safe',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-NDA-one-way-v2-2021-05-10.docx`],
    docKinds: ['NDA'],
  },
  {
    text: 'Two-Way NDA',
    tooltipTitle: `To keep everyone's secrets safe`,
    url: [`${bucketBaseUrl}/StartupTools-Sweden-NDA-two-way-v2-2021-05-10.docx`],
    docKinds: ['NDA'],
  },
];

const buttonsConsultingAgreement = [
  {
    text: 'Consulting Agreement',
    tooltipTitle: 'General business documents',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Consulting-Agreement-2022-09-15.docx`],
    docKinds: ['Consulting Agreement'],
  },
];

const buttonsLoanAgreement = [
  {
    text: 'Loan Agreement',
    tooltipTitle: 'General business documents',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Loan-Agreement-2024-02-21.docx`],
    docKinds: ['Loan Agreement'],
  },
];

const buttonsFormalities = [
  {
    text: 'Seed Investment Formalities',
    tooltipTitle: 'Board meetings & minutes, important!',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Seed-Investment-Formalities-2021-05-10.zip`],
    docKinds: ['Formalities'],
  },
];

const buttonsSHA = [
  {
    text: 'SHA Without Investors (Updated)',
    tooltipTitle: 'Use when you are just the founders ',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Shareholders-Agreement-Without-Investors-2025-03-12.docx`],
    docKinds: ['SHA', 'SHA Founders 2024'],
  },
  {
    text: 'SHA Only Small Investors (Updated)',
    tooltipTitle: 'Use when you bring in your first investors',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Shareholders-Agreement-With-Small-Investors-2025-04-15.docx`],
    docKinds: ['SHA', 'SHA Small 2024'],
  },
  {
    text: 'SHA With VC Lead Investors (Updated)',
    tooltipTitle: 'Use when you are getting VC funding ',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Shareholders-Agreement-With-VC-Lead-Investor-2025-03-12.docx`],
    docKinds: ['SHA', 'SHA VC 2024'],
  },
];

const buttonsSubscriptionAgreement = [
  {
    text: 'Subscription Agreement',
    tooltipTitle: `Use when share issue hasn't been registered within 6 months`,
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Subscription-Agreement-2021-05-10.docx`],
    docKinds: ['SubA'],
  },
  {
    text: 'Confirmation of Share Subscription ',
    tooltipTitle: 'Use for all investments',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Confirmation-of-Share-Subscription-2022-12-14.docx`],
    docKinds: ['Confirmation of Share Subscription'],
  },
];

const buttonsTermSheets = [
  {
    text: 'Term Sheet With Small Investors (Updated)',
    tooltipTitle: 'Use when you bring in your first investors',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Term-Sheet-With-Only-Small-Investors-2024.docx`],
    docKinds: ['Term Sheet'],
  },
  {
    text: 'Term Sheet with VC Lead Investors (Updated)',
    tooltipTitle: 'Use when you are getting VC funding',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Term-Sheet-With-VC-Lead-Investor-2024.docx`],
    docKinds: ['Term Sheet'],
  },
];

const buttonsWISE = [
  {
    text: 'WISE Convertible',
    tooltipTitle: 'Great for early investments',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-WISE-2021-08-19.zip`],
    docKinds: ['WISE'],
  },
];
const buttonsShareTransferAgreement = [
  {
    text: 'Share Transfer Agreement',
    tooltipTitle:
      'Use this document when you want to regulate the terms and details around a share transfer between two shareholders',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Share-Transfer-Agreement-2023-09-15.docx`],
    docKinds: ['Share Transfer Agreement'],
  },
];

const buttonsStockOptions = [
  {
    text: 'Qualified Employee Stock Options',
    tooltipTitle: 'Use to compensate employees',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Qualified-Employee-Stock-Option-Agreement-v5-Employee-2023-06-12.docx`],
    docKinds: ['QESO'],
  },
  {
    text: 'Qualified Board Stock Options',
    tooltipTitle: 'Use to compensate board members',
    url: [
      `${bucketBaseUrl}/StartupTools-Sweden-Qualified-Employee-Stock-Option-Agreement-v5-BoardMember-2023-06-12.docx`,
    ],
    docKinds: ['QESO'],
  },
  {
    text: 'Employee Warrants',
    tooltipTitle: 'Use to compensate employees',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Warrants-2021-05-10.zip`],
    docKinds: ['Employee Warrants'],
  },
  {
    text: 'Redemption of Warrants',
    tooltipTitle: 'Redeem warrants when needed',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Redemption-of-Warrants-2022-10-25.docx`],
    docKinds: ['Redemption of Warrants'],
  },
  {
    text: 'Transfer of Warrants',
    tooltipTitle: 'Transfer of Warrants',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Transfer-of-Warrants-2024-02-08.docx`],
    docKinds: ['Transfer of Warrants'],
  },
];

const buttonsEA = [
  {
    text: 'Hourly Wage',
    tooltipTitle: 'For employment on non-fixed terms',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Employment-Agreement-Hourly-2022-06-23.docx`],
    docKinds: ['Employee Agreements'],
  },
  {
    text: 'Managing Director',
    tooltipTitle: 'When you hire a CEO / MD',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Employment-Agreement-Managing-Director-2022-06-23.docx`],
    docKinds: ['Employee Agreements'],
  },
  {
    text: 'Permanent or Probationary Employment',
    tooltipTitle: 'The most common form of employment',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Employment-Agreement-Permanent-or-Probationary-2022-06-23.docx`],
    docKinds: ['Employee Agreements'],
  },
  {
    text: 'Information Letter',
    tooltipTitle: 'To comply with the 2022 LAS updates for existing employees',
    url: [`${bucketBaseUrl}/StartupTools-Sweden-Information-Letter-2022-06-23.docx`],
    docKinds: ['Information Letter'],
  },
];

const dynamicDivCardsContent = [
  {
    buttons: buttonsSWEAT,
    title: 'Advisors',
    iconName: 'groups_black',
    referToUrl: 'https://startuptools.org/se/sweat-advisor-options/',
    description:
      'Are you an entrepreneur looking for experienced advisors to support you in your startup journey? Look no further than SWEAT (Startup Warrants for Engaging Advisors Template). SWEAT offers a standardized approach to compensating advisors, reducing thresholds, costs, and headaches for both entrepreneurs and advisors.',
    showAnchor: true,
  },

  {
    buttons: buttonsNDA,
    title: 'Non-disclosure agreements',
    iconName: 'description_black',
    referToUrl: 'https://startuptools.org/se/non-disclosure-agreement/',
    description:
      'Non-disclosure agreements (NDAs) can play a valuable role in protecting sensitive information and fostering trust in certain stages of your startup journey. While they may not be necessary or effective in very early stages when pitching your idea, they become more relevant and useful as you progress and engage in discussions involving patent applications, partnerships, joint ventures, mergers, acquisitions, and similar scenarios.',
    showAnchor: true,
  },

  {
    buttons: buttonsConsultingAgreement,
    title: 'Consulting Agreement',
    iconName: 'description_black',
    referToUrl: 'https://startuptools.org/se/business-documents',
    description: `This is a consulting agreement for a Swedish company hiring a consultant on an hourly basis. It covers the engagement duration, duties, compensation, confidentiality, non-compete obligations, and ownership of intellectual property rights. The agreement emphasizes that the consultant is an independent contractor and is governed by Swedish law.`,
    showAnchor: false,
  },
  {
    buttons: buttonsLoanAgreement,
    title: 'Loan agreement',
    iconName: 'groups_black',
    referToUrl: 'https://startuptools.org/se/loan-agreement/',
    description: `Sometimes a company might need a temporary cash top-up to manage cashflow, and if you have a strong owner, or other connection for that matter, who is willing to lend the company money, it may be a great solution. We have a developed a simple Loan Agreement to that purpose.`,
    showAnchor: true,
  },
  {
    buttons: buttonsFounders,
    title: 'Articles of Association',
    iconName: 'description_black',
    referToUrl: 'https://startuptools.org/se/articles-of-association/',
    description: `The Articles of Association (bolagsordning) serve as a simplified version of the shareholders' agreement. They include essential information such as share numbers and company name. These articles are publicly registered and apply to all shareholders, regardless of their preferences. It is advisable to keep the articles basic and focus on detailed provisions in the shareholders' agreement.`,
    showAnchor: true,
  },
  {
    buttons: buttonsFormalities,
    title: 'Formalities',
    iconName: 'description_black',
    referToUrl: 'https://startuptools.org/se/startup-funding-overview/',
    description: `Here you will find proposal documents related to the issuance of new shares. The first document presents a proposal by the board of directors for a targeted new share issuance without shareholders' preferential rights. The second document contains the minutes of an extraordinary general meeting, detailing attendance, the adoption of new articles of association, and unanimous resolutions regarding the new share issuance.`,
    showAnchor: true,
  },
];

const rowCardsContent1 = [
  {
    cardGroup: [
      {
        buttons: buttonsSHA,
        title: "Shareholders' Agreements",
        iconName: 'receipt_long_black',
        referToUrl: 'https://startuptools.org/our-shareholders-agreements/',
        showAnchor: true,
      },
      {
        buttons: buttonsSubscriptionAgreement,
        title: 'Subscriptions',
        iconName: 'newspaper_black',
        referToUrl: 'https://startuptools.org/se/subscription-shareholders-agreement/',
        showAnchor: true,
      },
    ],
  },
  {
    cardGroup: [
      {
        buttons: buttonsTermSheets,
        title: 'Term Sheets',
        iconName: 'receipt_long_black',
        referToUrl: 'https://startuptools.org/se/term-sheet/',
        showAnchor: true,
      },
      {
        buttons: buttonsWISE,
        title: 'WISE',
        iconName: 'description_black',
        referToUrl: 'https://startuptools.org/se/wise-convertible/',
        showAnchor: true,
      },
      {
        buttons: buttonsShareTransferAgreement,
        title: 'Share Transfer Agreement',
        iconName: 'handshake_black',
        referToUrl: 'https://startuptools.org/se/',
        showAnchor: false,
      },
    ],
  },
];

const rowCardsContent2 = [
  {
    cardGroup: [
      {
        buttons: buttonsStockOptions,
        title: 'Stock Options',
        iconName: 'newspaper_black',
        referToUrl: 'https://startuptools.org/se/ultimate-guide-stock-options-swedish-startups/',
        showAnchor: true,
      },
    ],
  },
  {
    cardGroup: [
      {
        buttons: buttonsEA,
        title: 'Employment Agreements',
        iconName: 'groups_black',
        referToUrl: 'https://startuptools.org/se/employment-agreement/',
        showAnchor: true,
      },
    ],
  },
];

export const Main = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        width: isMobile ? '100%' : 'auto',
        margin: {
          xs: '0rem',
          sm: '0rem',
          md: '-3.375rem 4rem auto 4rem',
          lg: '-3.375rem 6rem auto 6rem',
          xl: '-3.375rem 8.125rem auto 8.125rem',
        },
        padding: '0rem',
      }}
    >
      <MainHeader
        headerText="For Shareholders and Investors"
        subHeaderText="Our Top Featured Documents"
        paddingTop={4.125}
        paddingLeft={isMobile ? 1.5 : 3.875}
        textAlign="left"
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          justifyContent: isMobile ? 'center' : 'initial',
          paddingTop: '3rem',
          paddingLeft: isMobile ? '0rem' : '4.125rem',
        }}
      >
        <MainCardRow cardData={rowCardsContent1} spacing={3} marginRightFirstEle={isMobile ? 0 : 2.8125} />
        <Box
          component="img"
          src="./assets/images/free_templates/laptop.svg"
          alt="Laptop with the view of the platform"
          sx={{
            width: 'auto',
            height: {
              xs: 'auto',
              sm: '10%',
              md: '60%',
              lg: '60%',
              xl: 'auto',
            },
            maxWidth: '100%',
            maxHeight: '100%',
            minWidth: {
              md: '50%',
              lg: '50%',
            },
            marginLeft: isMobile ? '0rem ' : '-2.0625rem',
            marginTop: {
              xs: '-2rem',
              sm: '-2rem',
              md: '2rem',
              lg: '1rem',
              xl: '-8.6875rem',
            },
            overflow: 'hidden',
          }}
        />
      </Box>
      <Box
        sx={{
          maxWidth: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          marginTop: isMobile ? '3rem' : '6.125rem',
          marginBottom: '2rem',
          overflow: 'hidden',
        }}
      >
        <MainHeader
          headerText="Get Your People Set Up the Right Way"
          subHeaderText="Employee Agreements & Stock Options"
          alignItems="center"
          paddingTop={0}
          paddingLeft="auto"
          textAlign="center"
        />
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: isMobile ? 'center' : 'initial',
            width: '100%',
            paddingTop: '3rem',
          }}
        >
          <MainCardRow cardData={rowCardsContent2} spacing={11} marginRightFirstEle={isMobile ? 0 : 5.5} />
        </Box>
      </Box>
      <Box
        sx={{
          backgroundColor: theme.palette.pro.background,
          padding: isMobile ? '0rem' : '4rem 5rem',
          paddingBottom: isMobile ? '2.25rem' : '5rem',
          marginTop: isMobile ? '2.25rem' : '9.75rem',
        }}
      >
        <Box
          sx={{
            paddingLeft: isMobile ? '1.5rem' : '0rem',
            paddingTop: isMobile ? '1.5rem' : '0rem',
            paddingBottom: isMobile ? '2rem' : '3rem',
            width: '100%',
            overflow: 'hidden',
          }}
        >
          <MainHeader
            headerText="Documents for Founders and Advisors"
            subHeaderText="More Documents & Templates"
            paddingTop={0}
            paddingLeft={0}
            textAlign="left"
          />
        </Box>

        {isMobile ? (
          <MobileMainDynamicDivContent contentObject={dynamicDivCardsContent} />
        ) : (
          <MainDynamicDivContent buttonNames={dynamicDivButtonsNames} contentObject={dynamicDivCardsContent} />
        )}
      </Box>
      <Box
        sx={{
          height: isMobile ? 'auto' : '45.25rem',
          marginBottom: isMobile ? '0rem' : 'auto',
          width: isMobile ? '100%' : 'auto',
          overflow: 'hidden',
        }}
      >
        <Stack
          display="flex"
          flexDirection={isMobile ? 'column' : 'row'}
          sx={{
            backgroundImage: `url('./assets/images/free_templates/Ellipse.svg')`,
            backgroundSize: isMobile ? 'auto' : '63.75rem 63.75rem',
            backgroundPosition: isMobile ? '-100rem' : '17.5rem -31.25rem',
            backgroundRepeat: 'no-repeat',
            overflow: 'hidden',
            width: isMobile ? '100%' : 'auto',
            marginBottom: {
              xs: '0rem',
              sm: '2rem',
              md: '2rem',
              lg: '0rem',
              xl: '0rem',
            },
          }}
        >
          <Box
            marginLeft={isMobile ? '1.5rem' : '3.875rem'}
            minWidth="40%"
            display="flex"
            flexDirection="column"
            alignItems="flex-start"
            flexWrap="wrap"
            sx={{
              marginTop: {
                xs: '2rem',
                sm: '2rem',
                md: '8rem',
                lg: '10rem',
                xl: '14.625rem',
              },
              marginLeft: {
                xs: '1.5rem',
                sm: '1.5rem',
                md: '1.5rem',
                lg: '3.875rem',
                xl: '3.875rem',
              },
            }}
          >
            <Typography
              level="h3"
              sx={{
                fontFamily: 'Inter',
                fontWeight: 700,
                fontSize: '2rem',
                lineHeight: '2.05rem',
                maxWidth: '88%',
                wordWrap: 'break-word',
              }}
            >
              Reach Out to Us for Legal Support
            </Typography>
            <Typography
              level="body-lg"
              sx={{
                whiteSpace: 'pre-wrap',
                overflowWrap: 'break-word',
                maxWidth: isMobile ? '88%' : 'auto',
                marginTop: '2rem',
              }}
            >
              As a complement to our free templates & new platform, we also offer paid professional legal services
              together with a partner.
            </Typography>
            <Typography
              level="body-lg"
              sx={{
                whiteSpace: 'pre-wrap',
                overflowWrap: 'break-word',
                maxWidth: isMobile ? '88%' : 'auto',
                marginTop: '2rem',
              }}
            >
              We have chosen our partner with care, to ensure we find someone who truly understands startups, can
              deliver at the level of excellence we expect, and at a price point startups can tolerate.
            </Typography>
            <a
              href={`https://bolago.com/meeting/BookDemo`}
              style={{ textDecoration: 'none' }}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button sx={{ width: isMobile ? 'auto' : '11.75rem', marginTop: '2rem' }}>Book Consultation</Button>
            </a>
          </Box>
          <Box
            component="img"
            src="./assets/images/free_templates/Ellipse.svg"
            alt="Ellipse shaped graphic"
            sx={{
              width: isMobile ? '100%' : '32.125rem',
              height: isMobile ? 'auto' : '24.1875rem',
              marginTop: {
                xs: '2rem',
                sm: '2rem',
                md: '9rem',
                lg: '12.0625rem',
                xl: '12.0625rem',
              },
              marginLeft: {
                xs: 'auto',
                sm: '8rem',
                md: '10rem',
                lg: '12rem',
                xl: '13.5rem',
              },
            }}
          />
        </Stack>
      </Box>
    </Box>
  );
};
